"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import DateFormat from "@/framework/timeformatter";
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v8/cookies-backup")
);
let CookieManageDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.shopItem = null;
    this.searchOperateName = "";
    this.os = null;
    this.gridController = _gridController;
    this.searchData = {
      onlyme: false,
      datestatus: "NOT_EXPIRED",
      methodstatus: "",
      datepicker: ""
    };
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.pagePosition = "dialog";
    });
  }
  open(item) {
    return __async(this, null, function* () {
      try {
        this.shopItem = item;
        yield this.getVersion();
        this.searchData.datestatus = "NOT_EXPIRED";
        this.gridController.query.filter = `status==${this.searchData.datestatus};shopGuid==${item.shopOldId}`;
        yield this.gridController.search();
        this.dialog.visible = true;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //日期类型转换
  format_date(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatter(DateFormat.check(time));
    }
  }
  getVersion() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.local/system/devices`);
        this.os = response.data.os.name;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  reverseCookie(row) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(
          this.$t("cookie_manage_dialog.reverse_cookie_warning_content", {
            os: this.os
          }),
          this.$t("cookie_manage_dialog.reverse_cookie_warning_title"),
          {
            confirmButtonText: this.$t("cookie_manage_dialog.confirm"),
            cancelButtonText: this.$t("cookie_manage_dialog.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        yield API.post(`api://base.auth/api/v8/shop-cookies/${this.shopItem.shopOldId}`, {
          model: "recover_sync",
          cookieBackupId: row.id
        });
        this.$message.success(
          this.$t("cookie_manage_dialog.reverse_cookie_success")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  highCommand(command) {
    switch (command) {
      case "open-log":
        this.toOpenLog();
        break;
    }
  }
  toOpenEditStatus(row) {
    try {
      this.$emit("openEditStatus", row);
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  handleTableOperation(command) {
    return __async(this, null, function* () {
      console.log(command);
      switch (command.name) {
        case "edit-status":
          this.toOpenEditStatus(command.row);
          break;
        case "sync-to-mac":
          yield this.syncToMac(command.row);
          break;
        case "sync-to-windows":
          yield this.syncToWindows(command.row);
          break;
        case "delete-cookie":
          yield this.deleteCookie(command.row);
          break;
        case "remark-status":
          this.openRemarkEditDialog(command.row);
          break;
      }
    });
  }
  syncToWindows(row) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(
          this.$t("cookie_manage_dialog.reverse_cookie_to_windows_content", {
            os: this.os
          }),
          this.$t("cookie_manage_dialog.reverse_cookie_to_windows_title"),
          {
            confirmButtonText: this.$t("cookie_manage_dialog.confirm"),
            cancelButtonText: this.$t("cookie_manage_dialog.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        yield API.post(`api://base.auth/api/v8/shop-cookies/${this.shopItem.shopOldId}`, {
          model: "recover_sync",
          cookieBackupId: row.id,
          os: "windows"
        });
        this.$message.success(
          this.$t("cookie_manage_dialog.reverse_cookie_success")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  syncToMac(row) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(
          this.$t("cookie_manage_dialog.reverse_cookie_to_mac_content", {
            os: this.os
          }),
          this.$t("cookie_manage_dialog.reverse_cookie_to_windows_title"),
          {
            confirmButtonText: this.$t("cookie_manage_dialog.confirm"),
            cancelButtonText: this.$t("cookie_manage_dialog.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        yield API.post(`api://base.auth/api/v8/shop-cookies/${this.shopItem.shopOldId}`, {
          model: "recover_sync",
          cookieBackupId: row.id,
          os: "mac"
        });
        this.$message.success(
          this.$t("cookie_manage_dialog.reverse_cookie_success")
        );
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  openRemarkEditDialog(row) {
    return __async(this, null, function* () {
      this.$emit("openEditRemark", row);
    });
  }
  deleteCookie(row) {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.warnconfirm(
          this.$t("cookie_manage_dialog.delete_cookie_content"),
          this.$t("cookie_manage_dialog.delete_cookie_title"),
          {
            confirmButtonText: this.$t("cookie_manage_dialog.confirm"),
            cancelButtonText: this.$t("cookie_manage_dialog.cancel"),
            iconClass: "el-icon-warning"
          }
        );
        yield API.delete(`api://base.auth/api/v8/cookies-backup/${row.id}`);
        this.$message.success(this.$t("cookie_manage_dialog.delete_cookie_success"));
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  close() {
    return __async(this, null, function* () {
      try {
        this.searchData = {
          datestatus: "NOT_EXPIRED",
          methodstatus: "",
          datepicker: "",
          onlyme: false
        };
        this.searchOperateName = "";
        this.dialog.visible = false;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.SearchData();
    });
  }
  SearchData() {
    return __async(this, null, function* () {
      try {
        let searchs = [];
        searchs.push(`shopGuid==${this.shopItem.shopOldId}`);
        if (this.searchData.datestatus !== "" && this.searchData.datestatus !== null) {
          searchs.push(`status==${this.searchData.datestatus}`);
        }
        if (this.searchData.methodstatus !== "" && this.searchData.methodstatus !== null) {
          searchs.push(`type==${this.searchData.methodstatus}`);
        }
        if (this.searchOperateName !== "" && this.searchOperateName !== null) {
          searchs.push(`name=='%${this.searchOperateName}%'`);
        }
        if (this.searchData.onlyme !== false) {
          searchs.push(`self == 1`);
        }
        if (this.searchData.datepicker !== null && this.searchData.datepicker !== "") {
          searchs.push(`createdTime>=${this.searchData.datepicker[0].getTime()};createdTime<=${this.searchData.datepicker[1].getTime()}`);
        }
        searchs = searchs.join(";");
        this.gridController.query.filter = searchs;
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  resetButton() {
    return __async(this, null, function* () {
      try {
        this.searchData = {
          datestatus: "NOT_EXPIRED",
          methodstatus: "",
          datepicker: "",
          onlyme: false
        };
        this.searchOperateName = "";
        this.gridController.query.filter = `status==${this.searchData.datestatus};shopGuid==${this.shopItem.shopOldId}`;
        this.gridController.query.current = 1;
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  toOpenLog() {
    this.$emit("openLogDialog", this.shopItem);
  }
};
__decorateClass([
  Debounce(400)
], CookieManageDialog.prototype, "SearchData", 1);
CookieManageDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid
    }
  })
], CookieManageDialog);
export {
  CookieManageDialog as default
};
